export default __webpack_public_path__ + "static/media/circle-illustration.a45f6081.png";